// src/services/EmailService.js

import axios from 'axios';
import config from '../config';

const EmailService = {
  getAll: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/emails`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  create: async (data) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${config.apiBaseUrl}/emails`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  get: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/emails/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  update: async (id, data) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${config.apiBaseUrl}/emails/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};

export default EmailService;
